import { render } from "./ProjectTypes.vue?vue&type=template&id=2d11974c"
import script from "./ProjectTypes.vue?vue&type=script&lang=js"
export * from "./ProjectTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__